import { WorkspaceFileFilterParameters, WorkspaceFilterDropdownOption } from '../../@core/interfaces';

export const workspaceFileColumns: { [key: string]: string } = {
  name: 'entity_name.keyword',
  lastModified: 'modified_date',
  fileSize: 'size',
  fileType: 'entity_type',
};

// Object containing mapping for file types where we do not want to display their extensions in workspace content list
// and file details component
export const WorkspaceDetailFileTypes: {
  [key: string]: string;
} = {
  xls: 'Excel',
  xlsx: 'Excel',
  ipynb: 'Notebook',
};

// Object containing mapping of file types with their respective viewers
// for example: PDF, TXT and HTML files can be viewed using iframe tag
//            - Excel and other tabular format files can be viewed using xlsx library, etc.
export const FileTypePreview: {
  [key: string]: string;
} = {
  pdf: 'IframeViewer',
  json: 'IframeViewer',
  txt: 'IframeViewer',
  html: 'IframeViewer',
  Excel: 'TabularFileViewer',
  csv: 'TabularFileViewer',
  tsv: 'TabularFileViewer',
  jpg: 'ImageFileViewer',
  jpeg: 'ImageFileViewer',
  png: 'ImageFileViewer',
  gif: 'ImageFileViewer',
  Notebook: 'NotebookFileViewer',
};

export const MAX_COLUMNS_TABULAR_FILES_PREVIEW: number = 50;
export const MAX_ROWS_TABULAR_FILES_PREVIEW: number = 100;
export const MAX_FILE_SIZE_PREVIEW: number = 4; // 4 MB for maximum size allowed for tabular file preview
export const MAX_REPORT_FILE_SIZE_PREVIEW: number = 5.5; // 5.5 MB for maximum size allowed for report file preview
export const MAX_FILE_SIZE_COPY_MOVE_RENAME_OPERATION: number = 5368709120; // 5 GB i.e. 5368709120 in Bytes
export const MAX_FOLDER_SIZE_COPY_MOVE_RENAME_OPERATION: number = 107374182400; // 100 GB i.e. 107374182400 in Bytes

// Elastic search API endpoints for workspaces listing/searching and workspace/folder content listing/searching
export const ES_WORKSPACE_CONTENT_ENDPOINT: string = 'workspaces';
export const ES_WORKSPACE_CONTENT_COUNT_ENDPOINT: string = 'workspaces/{workspace-id}/_count';
export const ES_WORKSPACES_ENDPOINT: string = 'mithoo/_search';

/**
 * Used for fetching just the files (files, notebooks) count from elastic search APIs
 */
export const fileTypeFilter: WorkspaceFileFilterParameters = {
  showFiles: true,
  showNotebooks: true,
  showAnalysis: false,
  showFolders: false,
  filtersCleared: false
};

/**
 * Used for fetching folders count from elastic search APIs
 */
export const folderTypeFilter: WorkspaceFileFilterParameters = {
  showFiles: false,
  showNotebooks: false,
  showAnalysis: false,
  showFolders: true,
  filtersCleared: false
};

/**
 * Used for fetching just analyses count from elastic search APIs
 */
export const runsTypeFilter: WorkspaceFileFilterParameters = {
  showFiles: false,
  showNotebooks: false,
  showAnalysis: true,
  showFolders: false,
  filtersCleared: false
};

enum WorkspaceFilterValues {
  ALL = 'All Workspaces',
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
  SHARED_WITH_YOU = 'Shared with you',
  OWNED_BY_YOU = 'Owned by you',
  FAVOURITES = 'Favourites',
}

export const WorkspaceFilterDropdown: WorkspaceFilterDropdownOption[] = [
  {
    name: WorkspaceFilterValues.ALL,
    value: { showAll: true },
  },
  {
    name: WorkspaceFilterValues.FAVOURITES,
    value: { showFavourites: true },
  },
  {
    name: WorkspaceFilterValues.OWNED_BY_YOU,
    value: { showOwned: true },
  },
  {
    name: WorkspaceFilterValues.SHARED_WITH_YOU,
    value: { showShared: true },
  },
  {
    name: WorkspaceFilterValues.ARCHIVED,
    value: { showArchived: true },
  },
];

export const WORKSPACE_FILTERS_UI_MAP: {
  [key: string]: string;
} = {
  showAll: WorkspaceFilterValues.ALL,
  showActive: WorkspaceFilterValues.ACTIVE,
  showArchived: WorkspaceFilterValues.ARCHIVED,
  showFavourites: WorkspaceFilterValues.FAVOURITES,
  showOwned: WorkspaceFilterValues.OWNED_BY_YOU,
  showShared: WorkspaceFilterValues.SHARED_WITH_YOU,
};

export enum ES_WORKSPACES_INDICES {
  CONTENT_INDEX = '{document_index}',
  WORKSPACE_INDEX = '{workspace_index}',
}

export const MAX_SIZE_COLLABORATORS_LIST: number = 5;

export const AVATAR_BG_COLOR_LIST: string[] = ['purple', 'orange', 'pink', 'cyan', 'blue'];
